/**
 * GET /api/billing/upgrade-preview answers 409 when it won't state a price for this
 * change. That's a decision, not a failed lookup: confirming would go on to charge at
 * a price nobody was shown, so the caller shows this message and doesn't offer to
 * confirm. Anything else that goes wrong returns null, and the caller carries on.
 */
export function previewRefusalMessage(error: unknown): string | null {
  const e = error as { status?: unknown; data?: { message?: unknown } } | null | undefined;
  if (e?.status !== 409) return null;
  const message = e.data?.message;
  return typeof message === 'string' && message.trim()
    ? message
    : "This plan change isn't available right now. Contact support and we'll sort it out.";
}
